module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dark"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "side-nav side-nav-left center"
  }, [_c('div', {
    staticClass: "rotate"
  }, [_c('router-link', {
    attrs: {
      "to": "/type-categories"
    }
  }, [_vm._v("▲"), _c('br'), _vm._v("Type Categories")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "side-nav side-nav-right center"
  }, [_c('div', {
    staticClass: "rotate"
  }, [_c('router-link', {
    attrs: {
      "to": "/emoticons-text"
    }
  }, [_vm._v("Emoticons & Text"), _c('br'), _vm._v("▼")])], 1)]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "content lightblue clear"
  }, [_c('div', {
    staticClass: "column--single img--100 spacer--large text--blue"
  }, [_c('div', {
    staticClass: "spacer--small"
  }), _vm._v(" "), _c('div', {
    staticClass: "column--single dashes--flex",
    attrs: {
      "data-style": "display: flex;"
    }
  }, [_c('div', {
    staticClass: "column--half lightpink spacer--small dashes--flex-item variable-height",
    on: {
      "mouseover": function($event) {
        _vm.activate('hyphen')
      },
      "mouseout": function($event) {
        _vm.disable('hyphen')
      }
    }
  }, [_c('h3', {
    staticClass: "caps center"
  }, [_vm._v("Hyphen")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.active.hyphen),
      expression: "active.hyphen"
    }]
  }, [_c('img', {
    staticClass: "spacer--small",
    attrs: {
      "src": "/static/images/italics-dashes/hyphen.svg",
      "alt": "Hyphen"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "column--single caption serif"
  }, [_vm._v("Hyphens are not needed in Korean—even when splitting words from the end of a line to the beginning of the next.")]), _c('br')]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.active.hyphen),
      expression: "!active.hyphen"
    }],
    staticClass: "column--single spacer--small black text-1"
  }, [_vm._v("\n                  Look at that good"), _c('span', {
    staticClass: "emphasis"
  }, [_vm._v("-")]), _vm._v("looking, light"), _c('span', {
    staticClass: "emphasis"
  }, [_vm._v("-")]), _vm._v("headed, T"), _c('span', {
    staticClass: "emphasis"
  }, [_vm._v("-")]), _vm._v("rex!\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "spacer--tiny"
  })]), _vm._v(" "), _c('div', {
    staticClass: "column--half light spacer--small dashes--flex-item variable-height",
    on: {
      "mouseover": function($event) {
        _vm.activate('endash')
      },
      "mouseout": function($event) {
        _vm.disable('endash')
      }
    }
  }, [_c('h3', {
    staticClass: "caps center"
  }, [_vm._v("En Dash")]), _vm._v(" "), _c('div', {
    staticClass: "serif center"
  }, [_vm._v("\n                  Connect Ranges\n                ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.active.endash),
      expression: "active.endash"
    }]
  }, [_c('img', {
    staticClass: "spacer--small",
    attrs: {
      "src": "/static/images/italics-dashes/endash.svg",
      "alt": "En Dash"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "column--single caption serif"
  }, [_vm._v("En dashes are used in the same way in both languages, replacing the words ‘to’ and ‘from’ when writing values.")]), _c('br')]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.active.endash),
      expression: "!active.endash"
    }],
    staticClass: "black column--single spacer--small text-2"
  }, [_vm._v("\n                  In class from 9AM"), _c('span', {
    staticClass: "emphasis"
  }, [_vm._v("–")]), _vm._v("6PM please read pages 27"), _c('span', {
    staticClass: "emphasis"
  }, [_vm._v("–")]), _vm._v("56 of the textbook this Monday"), _c('span', {
    staticClass: "emphasis"
  }, [_vm._v("–")]), _vm._v("Wednesday.\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "spacer--tiny"
  })]), _vm._v(" "), _c('div', {
    staticClass: "column--half white-or-pink spacer--small variable-height",
    on: {
      "mouseover": function($event) {
        _vm.activate('emdash')
      },
      "mouseout": function($event) {
        _vm.disable('emdash')
      }
    }
  }, [_c('h3', {
    staticClass: "caps center"
  }, [_vm._v("Em Dash")]), _vm._v(" "), _c('div', {
    staticClass: "serif center"
  }, [_vm._v("\n                  Connect Phrases\n                ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.active.emdash),
      expression: "active.emdash"
    }]
  }, [_c('img', {
    staticClass: "spacer--small",
    attrs: {
      "src": "/static/images/italics-dashes/emdash.svg",
      "alt": "Em Dash"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "column--single caption serif"
  }, [_vm._v("The em dash emphasizes a break in thought, this usage remains the same between English and Korean. It can be used in place of commas.")]), _c('br')]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.active.emdash),
      expression: "!active.emdash"
    }],
    staticClass: "black column--single spacer--small text-3"
  }, [_vm._v("\n                  She decided"), _c('span', {
    staticClass: "emphasis"
  }, [_vm._v("—")]), _vm._v("against her will"), _c('span', {
    staticClass: "emphasis"
  }, [_vm._v("—")]), _vm._v("that she would not eat the entire cake"), _c('span', {
    staticClass: "emphasis"
  }, [_vm._v("—")]), _vm._v("no matter how delicious"), _c('span', {
    staticClass: "emphasis"
  }, [_vm._v("—")]), _vm._v("in one sitting.\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "spacer--tiny"
  })]), _vm._v(" "), _c('div', {
    staticClass: "column--half pink-or-white spacer--small variable-height",
    on: {
      "mouseover": function($event) {
        _vm.activate('tilde')
      },
      "mouseout": function($event) {
        _vm.disable('tilde')
      }
    }
  }, [_c('h3', {
    staticClass: "caps center"
  }, [_vm._v("Tilde")]), _vm._v(" "), _c('div', {
    staticClass: "serif center"
  }, [_vm._v("\n                  Approximately / Accent / Happy\n                ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.active.tilde),
      expression: "active.tilde"
    }]
  }, [_c('img', {
    staticClass: "spacer--small",
    attrs: {
      "src": "/static/images/italics-dashes/tilde.svg",
      "alt": "Tilde"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "column--single caption serif"
  }, [_vm._v("Used as an accent over letters and also as a symbol for ‘approximately.’ In Korean it is used in informal text to mean you are happy. The more tilde’s, the more happiness.")]), _c('br')]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.active.tilde),
      expression: "!active.tilde"
    }],
    staticClass: "black column--single spacer--small black text-4"
  }, [_vm._v("\n                  Lets break the piñata in "), _c('span', {
    staticClass: "emphasis"
  }, [_vm._v("~")]), _vm._v("10 minutes; Thank you"), _c('span', {
    staticClass: "emphasis"
  }, [_vm._v("~~")])]), _vm._v(" "), _c('div', {
    staticClass: "spacer--tiny"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('div', {
    staticClass: "spacer--medium center"
  }, [_c('router-link', {
    staticClass: "button caps",
    attrs: {
      "to": "/emoticons-text"
    }
  }, [_vm._v("Next Chapter")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-wrap clear"
  }, [_c('div', {
    staticClass: "header-container"
  }, [_c('div', {
    staticClass: "header-section-title-conno caps rotate"
  }, [_vm._v("\n          Connotatives\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "header-content"
  }, [_c('span', {
    staticClass: "header-section-number"
  }, [_vm._v("2–1")]), _vm._v(" "), _c('h1', [_vm._v("Italics, -, –, —, and ˜")]), _vm._v(" "), _c('p', {
    staticClass: "header-section-desc"
  }, [_vm._v("Italics, scripts, and all of those dashes have unique purposes.")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content--first mediumblue clear"
  }, [_c('div', {
    staticClass: "column--single img--100 spacer--medium"
  }, [_c('div', {
    staticClass: "column--single"
  }, [_c('div', {
    staticClass: "column--half-br"
  }, [_c('h2', {
    staticClass: "text--lightpink caps center"
  }, [_vm._v("Italic")]), _vm._v(" "), _c('div', {
    staticClass: "serif text--lightpink center"
  }, [_vm._v("In a Font Family")]), _vm._v(" "), _c('p', {
    staticClass: "center spacer--small"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/italics-dashes/kr-italic.svg",
      "alt": "Italic"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "text--lightpink caption caps"
  }, [_vm._v("Typeface")]), _c('br'), _c('span', {
    staticClass: "caps bold text--blue"
  }, [_vm._v("Nanum Myeongjo, Skewed")])]), _vm._v(" "), _c('div', {
    staticClass: "spacer--small center"
  }, [_c('img', {
    staticClass: "img--minirule",
    attrs: {
      "src": "/static/images/mini-rule.svg",
      "alt": "divider"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center spacer--small"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/italics-dashes/en-italic.svg",
      "alt": "Italic"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "text--lightpink caption caps"
  }, [_vm._v("Typeface")]), _c('br'), _c('span', {
    staticClass: "caps bold text--blue"
  }, [_vm._v("Kepler Italic")])]), _vm._v(" "), _c('p', {
    staticClass: "serif caption text--lightpink column--single spacer--small"
  }, [_vm._v("Custom italics within a font family are not usually made in Korean. Possibly due to the roughly 11,000 charcters required to represent each character block combination, Korean italics are often simply skewed versions of the original.")])]), _vm._v(" "), _c('div', {
    staticClass: "column--half-br"
  }, [_c('h2', {
    staticClass: "text--lightpink caps center"
  }, [_vm._v("Script")]), _vm._v(" "), _c('div', {
    staticClass: "serif text--lightpink center"
  }, [_vm._v("Standalone Typeface")]), _vm._v(" "), _c('p', {
    staticClass: "center spacer--small"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/italics-dashes/kr-script.svg",
      "alt": "Italic"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "text--lightpink caption caps"
  }, [_vm._v("Typeface")]), _c('br'), _c('span', {
    staticClass: "caps bold text--blue"
  }, [_vm._v("Nanum Brush Script")])]), _vm._v(" "), _c('div', {
    staticClass: "spacer--small center"
  }, [_c('img', {
    staticClass: "img--minirule",
    attrs: {
      "src": "/static/images/mini-rule.svg",
      "alt": "divider"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center spacer--small"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/italics-dashes/en-script.svg",
      "alt": "Italic"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "text--lightpink caption caps"
  }, [_vm._v("Typeface")]), _c('br'), _c('span', {
    staticClass: "caps bold text--blue"
  }, [_vm._v("Braxton")])]), _vm._v(" "), _c('p', {
    staticClass: "serif caption text--lightpink column--single spacer--small"
  }, [_vm._v("The origin of the italic is based off of the natural angle of letters when written by hand. The English and Hangul scripts both have a hand written influence.")])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "serif center"
  }, [_vm._v("\n                  Connect Two Words"), _c('br')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d03c5108","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ItalicsDashes.vue
// module id = 157
// module chunks = 0